var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 280,
    viewBox: "0 0 131 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.752 127.416C153.403 125.428 151.449 123.945 149.231 123.243L50.0353 92.2818C58.4493 74.9569 72.0112 61.1622 88.8528 52.7976C105.695 44.433 124.987 41.9101 144.074 45.5763L155.626 48.0245L128.347 0.77613L126.201 0.721107C104.775 0.416991 83.9489 5.44532 65.45 15.3891C46.951 25.333 31.312 39.9058 19.8297 57.8993L19.4946 58.4457C14.3322 66.7085 10.0818 75.5915 6.81735 84.9407C4.17786 93.6244 2.06372 102.506 0.486764 111.536C0.0238644 113.982 0.484319 116.586 1.77505 118.821C3.06578 121.057 5.09055 122.758 7.44019 123.58L108.436 154.564L84.7716 257.522C84.3087 259.968 84.7692 262.571 86.0599 264.807C87.3507 267.043 89.3754 268.743 91.7251 269.565C100.334 272.715 109.083 275.325 117.923 277.381C127.651 279.228 137.47 279.989 147.207 279.649L147.847 279.632C169.171 278.685 189.611 272.428 207.472 261.379C225.333 250.331 240.101 234.809 250.551 216.101L251.576 214.215L224.297 166.967L220.642 178.195C214.273 196.558 202.442 212.004 186.777 222.407C171.112 232.81 152.385 237.658 133.174 236.282L155.959 134.895C156.459 132.624 156.152 130.19 155.105 128.028L155.13 128.014C155.07 127.912 155.009 127.812 154.946 127.712C154.891 127.608 154.835 127.505 154.776 127.402L154.752 127.416Z",
    fill: "#FFBC78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeft);
export default __webpack_public_path__ + "static/media/logo-left.cc33c21785d6c9a711ea967b3e212eb3.svg";
export { ForwardRef as ReactComponent };